// filepath: d:\work\cloud\cloud\Project\Frontend\src\components\SignagePlus\StatCard.js
import React from 'react'
import { FormattedMessage } from 'react-intl';
import './SignagePlus.css';

const StatCard = ({
  icon,
  title,
  number,
  unit,
  colors = [],
  width
}) => {

  return (
    <div
      className="stat-card d-flex flex-column justify-content-between px-3 py-3"
      style={{
        minWidth: 0,
        width: width
      }}
    >
      <div className="d-flex flex-row justify-content-between align-items-start">
        <div className="stat-card-title">
          <FormattedMessage id={title} />
        </div>
        <img src={icon} alt="" className="stat-card-icon" />
      </div>
      <div className="d-flex align-items-end flex-wrap mt-2">
        {Array.isArray(number)
          ? number.map((num, idx) => {
            const id = Array.isArray(unit) ? unit[idx] : unit;
            return (
              <React.Fragment key={idx}>
                <span
                  className="stat-card-number"
                  style={{
                    color: colors[idx] || '#202224'
                  }}
                >
                  {num}
                </span>
                <span
                  className="stat-card-unit"
                  style={{
                    color: colors[idx] || '#202224'
                  }}
                >
                  {typeof id === 'string' && id
                    ? <FormattedMessage id={id} />
                    : ''}
                </span>
                {idx < number.length - 1 && (
                  <span className="stat-card-slash">/</span>
                )}
              </React.Fragment>
            );
          })
          : (
            <>
              <span
                className="stat-card-number"
                style={{
                  color: colors[0] || '#202224'
                }}
              >
                {number}
              </span>
              <span
                className="stat-card-unit"
                style={{
                  color: colors[0] || '#202224'
                }}
              >
                {typeof unit === 'string' && unit
                  ? <FormattedMessage id={unit} />
                  : ''}
              </span>
            </>
          )
        }
      </div>
    </div>
  );
};

export default StatCard;